import {
  CREATE_EMPLOYEE_FAILURE,
  CREATE_EMPLOYEE_REQUEST,
  GET_ALL_EMPLOYEE_REQUEST,
  GET_ALL_EMPLOYEE_SUCCESS,
  GET_ALL_EMPLOYEE_FAILURE,
  GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST,
  GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS,
  GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE,
  DELETE_EMPLOYEE_REQUEST,
  DELETE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_STATUS_REQUEST,
  UPDATE_EMPLOYEE_STATUS_FAILURE,
  DELETE_EMPLOYEE_SUCCESS,
} from "./ActionType";

const initialState = {
  employees: [],
  employeesPerformance: [],
  loading: false,
  error: "",
};

export const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EMPLOYEE_REQUEST:
      return { ...state, loading: true };

    case CREATE_EMPLOYEE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_EMPLOYEE_REQUEST:
    case GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, error: "", employees: action.payload };

    case GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS:
      return { ...state, loading: false, error: "", employeesPerformance: action.payload };

    case GET_ALL_EMPLOYEE_FAILURE:
    case GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_EMPLOYEE_REQUEST:
      return { ...state, loading: true };

    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        employees: state.employees?.response?.filter(emp => emp.id !== action.payload)  // Remove deleted category
      };

    case DELETE_EMPLOYEE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_EMPLOYEE_REQUEST:
    case UPDATE_EMPLOYEE_STATUS_REQUEST:
      return { ...state, loading: true };

    case UPDATE_EMPLOYEE_FAILURE:
    case UPDATE_EMPLOYEE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
